import { MenuItem } from '@app/components/various/Menu';
import { isDefined } from '@app/utils/is';
import { Dropdown } from '@typings';
import React from 'react';

interface Props {
  item: Dropdown.MenuItem;
  selectionMode: 'single' | 'multiple';
  isSelected?: boolean;
  isFocused?: boolean;
  onClick?: () => void;
}

export const DropdownMenuSelectableItem = React.forwardRef<HTMLButtonElement, Props>(
  ({ item, selectionMode, isSelected = false, isFocused = false, onClick }, ref) => {
    const { label, description, isDisabled, hasDivider, icon: Icon } = item;

    const isMultipleSelection = selectionMode === 'multiple';

    const handleClick = () => {
      onClick?.();
      item.onClick?.();
    };

    return (
      <MenuItem
        ref={ref}
        aria-checked={isSelected}
        isSelected={isSelected}
        role={isMultipleSelection ? 'menuitemcheckbox' : 'menuitemradio'}
        variant={isMultipleSelection ? 'checkbox' : 'list'}
        isDisabled={isDisabled}
        description={description}
        hasDivider={hasDivider}
        prefix={isDefined(Icon) ? <Icon className="size-4" /> : undefined}
        isFocused={isFocused}
        onClick={handleClick}
      >
        {label}
      </MenuItem>
    );
  },
);
